import React from 'react'
import { useToast } from '../lib/toast'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'

interface IToastProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string
  id: string
  autoClose?: boolean
  duration?: number
  variant?: 'default' | 'primary' | 'success' | 'warning' | 'error'
}

const Toast: React.FC<IToastProps> = ({
  id,
  title,
  duration = 5000,
  autoClose = true,
  variant = 'default'
}) => {
  const { deleteToast } = useToast()

  React.useEffect(() => {
    if (autoClose) {
      setTimeout(() => {
        // eslint-disable-next-line no-unused-expressions
        document.getElementById('toast-delete-button')?.click()
      }, duration)
    }
  }, [autoClose, duration])

  return (
    <div className={`toast toast-${variant}`}>
      {title}
      <span id='toast-delete-button' onClick={() => deleteToast(id)}>
        <FontAwesomeIcon icon={faTimes} />
      </span>
    </div>
  )
}

export default Toast
